function isHttps(value) {
  return /^https:\/\//i.test(String(value || ''));
}

export function roleHasLocalUniformInformation(role) {
  const uniform = role?.uniform || {};
  return Boolean(
    uniform.uniformDefinitionId
    || uniform.garmentId
    || uniform.colourId
  );
}

export function trustChecklist(config, trust, previewConfirmed) {
  const roles = Object.values(config?.roles || {});
  const includedRoles = roles.filter((role) => role?.included !== false);
  const journeys = Object.values(config?.journeys || {});
  const hospitalCards = Object.values(config?.hospitalInfo || {});
  const journeyLinks = journeys.flatMap((journey) => Object.values(journey?.linkOverrides || {}));
  const uniformReady = includedRoles.length > 0 && includedRoles.every(roleHasLocalUniformInformation);

  return [
    { id: 'profile', label: 'Trust profile is active', done: trust?.active !== false },
    { id: 'roles', label: 'At least one patient-facing role is configured', done: includedRoles.length > 0 },
    { id: 'uniforms', label: 'Configured roles have local uniform/professional dress information', done: uniformReady },
    { id: 'hospital', label: 'Know Your Hospital has at least one live Trust link', done: hospitalCards.some((item) => item?.state === 'available' && isHttps(item.url)) },
    { id: 'journey', label: 'At least one Hospital Journey is configured', done: journeys.length > 0 },
    { id: 'links', label: 'Configured Journey local links are complete', done: journeys.length > 0 && journeyLinks.length > 0 && journeyLinks.every((link) => isHttps(link?.url)) },
    { id: 'preview', label: 'Configured patient preview has been checked', done: previewConfirmed, manual: true },
  ];
}
